export default "__VITE_PUBLIC_ASSET__bc40d019__"